import { useEffect } from 'react';

function NotFoundRedirect() {
  useEffect(() => {
    const externalRoute = '/404';
    window.location.href = `${window.location.origin}${externalRoute}`;
  }, []);

  return null;
}

export default NotFoundRedirect;
